import {Component, Input} from '@angular/core';
import {UploaderComponent} from "./uploader.component";
import {APIService} from "../../shared/api.service";
import {NotifierService} from "../../shared/notifier.service";
import {NbDialogService, NbPosition} from "@nebular/theme";
import {ImageCropperComponent} from "ngx-image-cropper";
import {CropDialogComponent} from "../../dialogs/crop-dialog/crop-dialog.component";

@Component({
    selector: 'bst-photo-uploader',
    templateUrl: './photo-uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    standalone: false
})
export class PhotoUploaderComponent extends UploaderComponent{

  @Input() public accepts: string[] = ['image/png', 'image/jpeg'];
  @Input() public size: number = 2.1;
  @Input() public shape:'round'|'semi-round'|'rectangle' = 'round';
  @Input() public ratio: number = 1;
  @Input() public color: string = '#f7f9fc';

  NbPosition = NbPosition;

  constructor(protected api: APIService,
              protected notifier: NotifierService,
              protected dialog: NbDialogService) {
    super(api, notifier);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  fileChangeEvent(event: any): void {
    this.subs.push(this.dialog.open<CropDialogComponent>(CropDialogComponent, {
      closeOnBackdropClick: false,
      context: {
        round: this.shape === 'round',
        ratio: this.ratio,
        file: event.target.files[0],
        background: this.color
      }
    }).onClose.subscribe(async (cropped: ImageCropperComponent) => {
      if(cropped?.cropper){
        this.data = this.data ?? {};
        const cropinfo = await cropped.crop();
        this.data._crop = JSON.stringify(cropinfo.imagePosition);
        await this.onFileSelected(event);
      }
    }));
  }

}
